import { isDate, parseISO, getYear, format, isValid } from 'date-fns'

export const DISPLAY_DATE_FORMAT = 'dd/MM/yyyy'
export const DISPLAY_DATE_FORMAT_FRIENDLY = 'dd MMMM yyyy'
export const ISO_DATE_FORMAT = 'yyyy-MM-dd'

export function formatDateForDisplay(date: Date) {
  return format(date, DISPLAY_DATE_FORMAT)
}

export function formatDateForDisplayFriendly(date: Date) {
  return format(date, DISPLAY_DATE_FORMAT_FRIENDLY)
}

export function formatIsoDate(date: Date): string {
  return format(date, ISO_DATE_FORMAT)
}

export function getYearFromIsoDate(date: string) {
  return getYear(parseISO(date))
}

/**
 * The date transform to be used together with DateInput & Yup validation
 * It'll make sure that it parse the date in a way that help Yup to produce
 * the correct message between `.required()` & `.typeError()` validation
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function yupDateTransform(value: any, originalValue: any) {
  if (!originalValue) {
    return null
  }

  if (isDate(originalValue)) {
    return originalValue
  }

  return parseISODateInputVal(originalValue)
}

/**
 * A custom utility to prevent date-fns from parsing value like : '0000-00-01'
 * Can occurs while user is in the process of typing the date via our <DateInput /> component
 */
export function parseISODateInputVal(val: string | null) {
  if (!val) {
    return null
  }

  const [year, month, date] = val.split('-')
  if (!year || !month || !date || year[0] === '0' || month === '00' || date === '00') {
    return null
  }

  const parsed = parseISO(val)

  return isValid(parsed) ? parsed : null
}
